import { Inject, Injectable, Optional } from "@angular/core";
import { ApiList } from "./api";
import { MatDialog } from "@angular/material/dialog";
import { DashboardService } from "./dashboard.service";
import { forEach } from "lodash";
import moment from "moment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { API_SERVICE_TOKEN, PBF_TOKEN } from "../service/InjectionToken";
import { DialogService } from "../service/dialog.service";
import { getTranslation } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class DashboardPorletsService {
  public translation;
  private userInfo;
  private lang;
  // public config;
  public companyDropdownList = [];
  public currencyDropdownList = [];
  public currencyList = [];
  public portlets = [];
  public portletsCopy = [];
  public columnCount;
  public rowCount;
  public companyCharts = [];
  public portletData;
  public fundDropdownList;
  public allInvesteeList;
  public fundInvesteeList;
  public seletedAllInvestee: boolean;
  public colorsTotal = [
    "#0b5496",
    "#0081ff",
    "#22cce2",
    "#606ede",
    "#8598f7",
    "#00a744",
    "#12c177",
    "#fdbf5e",
    "#ff8a48",
    "#ea4258",
  ];
  public fetch_disabled: boolean = true;
  public update_loading: boolean = false;
  public currencyCode;
  public update_config;
  public loading_show: boolean = false;
  public img;
  public sortingPortlet = [];
  public pagingChanging = [];
  public timeMeasure;
  public entityList;
  public entityType;
  public selected_enyity_fileds = [];
  public isEntitySelectAll;
  public checkedAll: boolean = false;
  public selectedNum;
  public updated = false;
  public dataMartTables = {};
  public length = 0;
  public GetSourcesRes;
  public ListEntitiesRes;
  public templateList = [];
  public fieldsArr = {};
  public sourcesData = {};
  // newDashboard
  public portletResults_New = {}; // 以DataTable为单位 存储新数据
  public portletData_New = {}; // 以portlet为单位 存储新数据
  public portletFields_Temp = {}; // 存储当前portlet所用到的字段
  public dashboardConfig: any = {}; // 当前Dashboard的config, 用于获取orderByColumns
  public entityIds: any = [];
  public entityIdObj: any = {};
  public allFieldsObj = {};

  constructor(
    private api: ApiList,
    public dialog: MatDialog,
    private dialogService: DialogService,
    private DashboardService: DashboardService,
    private httpClient: HttpClient,
    @Optional() @Inject(PBF_TOKEN) private pbf: any,
    @Optional() @Inject(API_SERVICE_TOKEN) private http: any
  ) {}

  private setEntityType(res) {
    if (res && res.entityList && res.entityList.length) {
      const entityData = res.entityList[0];
      if (!entityData) {
        return res;
      }
      const { linkedType = "" } = entityData;
      if (!linkedType) {
        return res;
      }
      this.entityType =
        linkedType === "PropertyId"
          ? "Property"
          : linkedType === "portfolioCompId" ||
            linkedType === "assetCompId" ||
            linkedType === "otherCompId"
          ? "Company"
          : linkedType === "portfolioFundId" || linkedType === "assetFundId"
          ? "Fund"
          : "AssetPortfolio";
      res.entityType = this.entityType;
    }
    return res;
  }

  public GetDashboardV1(
    dashboardId: string,
    roGet,
    callback: Function,
    isRefresh = false,
    callbackForDashboard?: Function
  ) {
    if (!isRefresh) {
      this.portlets = [];
    }
    this.getInfo();
    const dataObj = { dashboardId, language: this.lang };
    this.http.post(this.api.urlList.GetDashboardV2, dataObj, (res) => {
      res = this.pbf.convertKeysToLowerCase(res);
      if (!res) {
        callback(null);
        return;
      }
      res = this.setEntityType(res);
      // 初始化fromDate
      if (res.fromDate === "1900-01-01T00:00:00Z") {
        res.fromDate = "";
      }
      if (callbackForDashboard) {
        callbackForDashboard(res);
      }
      this.entityIds =
        res.entityList && res.entityList.length > 0
          ? res.entityList.map((e) => {
              return e["linkedGuid"];
            })
          : [];
      if (res.entityList) this.entityList = [...res.entityList];
      this.entityIdObj = {
        id: JSON.stringify(this.entityIds),
      };
      this.portletResults_New[res.id] = {};
      this.portletData_New[res.id] = {};
      this.DashboardService.dashboardGroupId[res.id] = res.dashboardGroupId;
      this.DashboardService.dashboardGroupName[res.id] = res.dashboardGroupName;
      this.DashboardService.RegionDataSetId[res.id] = res.RegionDataSetId;
      this.DashboardService.dashboardName[res.id] = res.name;
      this.DashboardService.shareUsers[res.id] = res.sharedUsers;
      this.dashboardConfig[res.id] = res.config && JSON.parse(res.config);
      if (res) {
        // this.dataMartTables[res.id] = uniqBy(
        // 	res.dataMartTables,
        // 	"langCode"
        // );
        this.dataMartTables[res.id] = [...res.dataMartTables];
        this.sortDataMartTables(this.dataMartTables[res.id]);
        this.DashboardService.dashboardDescription = res.description;
        this.img = res.img;
        // 如果可选开始日期，屏蔽默认的1900-01-01
        this.currencyCode = res.currencyCode;
        //@ts-ignore
        this.columnCount = res.columnCount ? res.columnCount : 4;
        if (res.portlets) {
          if (!isRefresh) {
            this.portlets = JSON.parse(JSON.stringify(res.portlets));
          }
          this.rowCount =
            res.portlets.length > 0
              ? Math.max.apply(
                  Math,
                  res.portlets.map(function (o) {
                    return o.posY;
                  })
                ) + 2
              : 2;

          // new Dashboard
          if (this.portlets && this.portlets.length) {
            this.fieldsArr[res.id] = {};
            this.portlets.forEach((el) => {
              if (
                !Object.keys(this.fieldsArr[res.id]).includes(el.figureCode)
              ) {
                this.fieldsArr[res.id][el.figureCode] = JSON.parse(
                  el.config
                ).fields;
              }
            });

            this.portlets = this.portlets.filter((item) => item.figureCode);
            this.getDataByPortletsNew(
              this.portlets,
              (_res) => {
                callback(res, this.portlets);
              },
              null,
              isRefresh,
              res,
              roGet
            );
          } else {
            callback(res, this.portlets);
          }
        } else {
          this.portlets = [];
          this.columnCount = 4;
          this.rowCount = 2;
          callback(res, this.portlets);
        }
      }
    });
  }

  public filterTriggerGetData(portlet, filterSettings, dashboard, callback) {
    const config = portlet.config && JSON.parse(portlet.config);
    let id =
      portlet.id === "00000000-0000-0000-0000-000000000000"
        ? portlet.newId
        : portlet.id;
    let params = this.getParamsByPortlet(portlet, null, null, dashboard);
    let initFieldsArr;
    let curFieldsArr;
    if (!params.isTable) {
      // 赋值portletFields_Temp
      initFieldsArr = this.portletFields_Temp[id];
      curFieldsArr = params.displayColumnFilter.split(",");
      if (
        !initFieldsArr ||
        this.needGetPortletData(initFieldsArr, curFieldsArr)
      ) {
        this.portletFields_Temp[id] = curFieldsArr;
      }
    }
    if (filterSettings && filterSettings.length) {
      if (!params.columnFilter) {
        params.columnFilter = [];
      }
      config.filterSettings = filterSettings;

      filterSettings.forEach((setting) => {
        if (config.portletType === "pivot") {
          return;
        }
        const _field = config.fields.find(
          (item) => item.colName === setting.name
        );
        const Type = _field && _field.dataType;
        if (setting.items) {
          setting.items.forEach((item) => {
            params.columnFilter.push({
              Field: setting.name,
              Operator: "equal",
              Type,
              Value:
                Type === "date"
                  ? moment(item).format("yyyy-MM-DD")
                  : Type === "datetime"
                  ? moment(item).format("yyyy-MM-DD hh:mm:ss")
                  : item,
            });
          });
        } else if (setting.operator) {
          params.columnFilter.push({
            Field: setting.field,
            Operator: "equal",
            Type: setting.type,
            Value:
              setting.type === "date"
                ? moment(setting.value).format("yyyy-MM-DD")
                : setting.type === "datetime"
                ? moment(setting.value).format("yyyy-MM-DD hh:mm:ss")
                : setting.value,
          });
        }
      });
    } else {
      config.filterSettings = [];
    }
    if (params.columnFilter instanceof Array) {
      params.columnFilter = params.columnFilter.filter((item) => item.Field);
    }
    // json buffer
    params["dashboardVersion"] = 2;
    // json buffer
    this.httpClient
      .post(
        this.api.baseurl + this.api.urlList.GetPortletDataOrCreate,
        params,
        {
          headers: new HttpHeaders({
            Authorization: `Bearer`,
          }),
        }
      )
      .subscribe((result) => {
        result["data"].forEach((item) => {
          item.Sector = this.translation[item.Sector] || item.Sector;
        });
        this.portletData_New[dashboard.id][id] = result;
        this.pbf.triggerDashboardFilterChange.next({
          id: dashboard.id,
          newId: portlet.newId,
        });
        callback({ newId: portlet && portlet.newId, config });
      });
  }

  public removeParentheses(str) {
    return str.split("(").join("").split(")").join("").split('"').join("");
  }

  public getInfo() {
    this.translation = getTranslation();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.lang = this.pbf.getLanguageParams();
    this.translation.DASHBOARD_ROLLING = this.translation.DASHBOARD_ROLLING
      ? this.translation.DASHBOARD_ROLLING
      : "DASHBOARD_ROLLING";
  }

  /*     Financial Analysis I      get select Dropdown */
  public GetChartTypes() {
    // Chart Type
    return [
      {
        val: "mscombi2d",
        displayVal: this.translation.SINGLEY2D,
        hasSecondaryYAxis: false,
        canSelectStyle: true,
      },
      {
        val: "mscombi3d",
        displayVal: this.translation.SINGLEY3D,
        hasSecondaryYAxis: false,
        canSelectStyle: true,
      },
      {
        val: "mscombidy2d",
        displayVal: this.translation.DUALY2D,
        hasSecondaryYAxis: true,
        canSelectStyle: true,
      },
      {
        val: "msbar2d",
        displayVal: this.translation.BAR2D,
        hasSecondaryYAxis: false,
        canSelectStyle: false,
      },
      {
        val: "msbar3d",
        displayVal: this.translation.BAR3D,
        hasSecondaryYAxis: false,
        canSelectStyle: false,
      },
      {
        val: "stackedcolumn2dline",
        displayVal: this.translation.STACKEDBAR2D,
        hasSecondaryYAxis: false,
        canSelectStyle: true,
      },
      {
        val: "stackedcolumn3dline",
        displayVal: this.translation.STACKEDBAR3D,
        hasSecondaryYAxis: false,
        canSelectStyle: true,
      },
    ];
  }
  public getCompanyDropdown() {
    // company
    let data = {
      accountId: this.userInfo.accountId,
      username: this.userInfo.username,
      language: this.lang,
      companyType: "portfolio",
    };
    this.http.post(this.api.urlList.GetAllCompanyByAccount, data, (res) => {
      if (res) {
        this.companyDropdownList = res;
        // return res;
      }
    });
  }
  public getCurrencyDropdown() {
    // Currency
    let data = {
      accountId: this.userInfo.accountId,
      username: this.userInfo.username,
      language: this.lang,
      alias: "Currency",
    };
    this.http.post(this.api.urlList.GetDropdown, data, (res) => {
      if (res) {
        this.currencyDropdownList = res;
        // return res;
      }
    });
  }
  public GetTimeMeasure() {
    // Time Measure
    return [
      {
        key: "MTD", // 月度
        val: this.translation.MONTHLY,
      },
      {
        key: "QTD", // 季度
        val: this.translation.QUARTERLY,
      },
      {
        key: "SYTD", // 半年度
        val: this.translation.SEMIANNUALLY,
      },
      {
        key: "YTD", // 年度
        val: this.translation.ANNUALLY,
      },
      {
        key: "FYTD", // 年度（财政年度）
        val: this.translation.ANNUALLYFY,
      },
      {
        key: "LTM", // 最近十二个月
        val: this.translation.LAST12MONTH,
      },
    ];
  }
  public GetPeriods() {
    // Previous Period
    return [
      {
        val: 2,
        displayVal: this.translation.LAST2DATA,
      },
      {
        val: 3,
        displayVal: this.translation.LAST3DATA,
      },
      {
        val: 4,
        displayVal: this.translation.LAST4DATA,
      },
      {
        val: 5,
        displayVal: this.translation.LAST5DATA,
      },
      {
        val: 6,
        displayVal: this.translation.LAST6DATA,
      },
      {
        val: 7,
        displayVal: this.translation.LAST7DATA,
      },
      {
        val: 8,
        displayVal: this.translation.LAST8DATA,
      },
      {
        val: 9,
        displayVal: this.translation.LAST9DATA,
      },
      {
        val: 10,
        displayVal: this.translation.LAST10DATA,
      },
      {
        val: 11,
        displayVal: this.translation.LAST11DATA,
      },
      {
        val: 12,
        displayVal: this.translation.LAST12DATA,
      },
      {
        val: 13,
        displayVal: this.translation.LAST13DATA,
      },
      {
        val: 14,
        displayVal: this.translation.LAST14DATA,
      },
      {
        val: 15,
        displayVal: this.translation.LAST15DATA,
      },
      {
        val: 16,
        displayVal: this.translation.LAST16DATA,
      },
      {
        val: 17,
        displayVal: this.translation.LAST17DATA,
      },
      {
        val: 18,
        displayVal: this.translation.LAST18DATA,
      },
      {
        val: 19,
        displayVal: this.translation.LAST19DATA,
      },
      {
        val: 20,
        displayVal: this.translation.LAST20DATA,
      },
      {
        val: 21,
        displayVal: this.translation.LAST21DATA,
      },
      {
        val: 22,
        displayVal: this.translation.LAST22DATA,
      },
      {
        val: 23,
        displayVal: this.translation.LAST23DATA,
      },
      {
        val: 24,
        displayVal: this.translation.LAST24DATA,
      },
    ];
  }
  public GetFollowingPeriods() {
    // Following Period
    return [
      {
        val: 0,
        displayVal: this.translation.NONEXTDATA,
      },
      {
        val: 3,
        displayVal: this.translation.NEXT3DATA,
      },
      {
        val: 4,
        displayVal: this.translation.NEXT4DATA,
      },
      {
        val: 5,
        displayVal: this.translation.NEXT5DATA,
      },
      {
        val: 6,
        displayVal: this.translation.NEXT6DATA,
      },
      {
        val: 7,
        displayVal: this.translation.NEXT7DATA,
      },
      {
        val: 8,
        displayVal: this.translation.NEXT8DATA,
      },
      {
        val: 9,
        displayVal: this.translation.NEXT9DATA,
      },
      {
        val: 10,
        displayVal: this.translation.NEXT10DATA,
      },
      {
        val: 11,
        displayVal: this.translation.NEXT11DATA,
      },
      {
        val: 12,
        displayVal: this.translation.NEXT12DATA,
      },
    ];
  }
  public GetFinancialFigureCodes() {
    // Financial Type
    return [
      {
        key: "accountAssetFigure",
        val: this.translation.DASHD_ACCOUNTASSETFIGURE,
      },
      {
        key: "accountEquityFigure",
        val: this.translation.DASHD_ACCOUNTEQUITYFIGURE,
      },
      {
        key: "accountLiabilityFigure",
        val: this.translation.DASHD_ACCOUNTLIABILITYFIGURE,
      },
      {
        key: "accountPLFigure",
        val: this.translation.DASHD_ACCOUNTPLFIGURE,
      },
      {
        key: "accountCashflowFigure",
        val: this.translation.DASHD_ACCOUNTCASHFLOWFIGURE,
      },
      {
        key: "accountOperationKPIFigure",
        val: this.translation.DASHD_ACCOUNTOPERATIONKPIFIGURE,
      },
      {
        key: "accountRATIOFigure",
        val: this.translation.DASHD_ACCOUNTRATIOFIGURE,
      },
    ];
  }
  public GetFinancialSubType(financials) {
    var financialTypes = [];
    for (var item in financials) {
      financialTypes.push({
        subType: item["subType"],
        subTypeCode: item["subTypeCode"],
      });
    }

    return financialTypes;
  }
  public GetFinancialItems(id, key) {
    let data = {
      username: this.userInfo.username,
      accountId: this.userInfo.accountId,
      investeeIds: [id],
      figureCode: key,
      language: this.lang,
    };
    this.http.post(this.api.urlList.GetFinancialItems, data, (res) => {
      if (res) {
        return res;
      }
    });
  }
  /* get toggle */
  public GetTheme() {
    return [
      { key: "zune", val: this.translation.CHARTTHEME_ZUNE },
      { key: "ocean", val: this.translation.CHARTTHEME_OCEAN },
      { key: "carbon", val: this.translation.CHARTTHEME_CARBON },
    ];
  }
  public GetFollowingDataType() {
    return [
      { key: "budget", val: this.translation.BUDGET },
      { key: "forecast", val: this.translation.FORECAST },
      // { key: 'rolling', val: this.translation.DASHBOARD_ROLLING },
      { key: "rolling", val: "Rolling" },
    ];
  }
  public GetFormat() {
    return [
      { key: "number", val: this.translation.NUMBER },
      { key: "percentage", val: this.translation.PERCENTAGE },
    ];
  }
  public GetChartStyle() {
    return [
      { key: "bar", val: this.translation.BAR },
      { key: "line", val: this.translation.LINE },
      { key: "area", val: this.translation.AREA },
    ];
  }
  public GetDataTypes = function () {
    return [
      { key: "budget", val: this.translation.BUDGET },
      { key: "actual", val: this.translation.ACTUAL },
      { key: "forecast", val: this.translation.FORECAST },
      { key: "rolling", val: "Rolling" },
    ];
  };
  /*     Fund Operation Summary       */
  public getFundDropdown() {
    let data = {
      username: this.userInfo.username,
      accountId: this.userInfo.accountId,
      investorId: this.userInfo.accountId,
      language: this.lang,
    };
    this.http.post(this.api.urlList.GetFundListByInvestorId, data, (res) => {
      if (res) {
        this.fundDropdownList = res;
        // return res;
      }
    });
  }
  /*     Fund performance       */
  public GetGrouping() {
    return [
      { key: "null", val: "" },
      { key: "investor", val: this.translation.DASHD_GP_INVESTOR },
      { key: "fund", val: this.translation.DASHD_GP_FUND },
    ];
  }
  /*     Fund Operation Summary       */
  public getFundDropdown_(callbake: Function) {
    let data = {
      username: this.userInfo.username,
      accountId: this.userInfo.accountId,
      investorId: this.userInfo.accountId,
      language: this.lang,
    };
    this.http.post(this.api.urlList.GetFundListByInvestorId, data, (res) => {
      if (res) {
        this.fundDropdownList = res;
        // this.GetAllInvestee(res => {
        callbake();
        // });
      }
    });
  }
  /*     Investor position       */
  public GetAllInvestee(callbake: Function) {
    let data = {
      username: this.userInfo.username,
      accountId: this.userInfo.accountId,
      language: this.lang,
    };
    this.http.post(this.api.urlList.GetAllInvestee, data, (res) => {
      if (res) {
        this.allInvesteeList = res;
        callbake();
      }
    });
  }
  public pivotTableformatNumber(num) {
    switch (num) {
      case 1:
      case 2:
      case 3:
        return "#,###;(#,###)";
      case 4:
      case 5:
      case 6:
        return "#,###.0;(#,###.0)";
      case 7:
      case 8:
      case 9:
        return "#,###.00;(#,###.00)";
      case 10:
      case 11:
      case 12:
        return "#,###,,;(#,###,,)";
      case 13:
      case 14:
      case 15:
        return "#,###,,.0;(#,###,,.0)";
      case 16:
      case 17:
      case 18:
        return "#,###,,.00;(#,###,,.00)";
      default:
        return "#,###.00;-#,###.00";
    }
  }

  public pivotTableformatInteger(num) {
    switch (num) {
      case 1:
      case 3:
      case 4:
        return "#,###;(#,###)";
      case 4:
      case 5:
      case 6:
        return "#,###,,;(#,###,,)";
      default:
        return "#,###;(#,###)";
    }
  }

  public pivotTableformatPercent(num) {
    switch (num) {
      case 1:
      case 2:
      case 3:
        return "P";
      case 4:
      case 5:
      case 6:
        return "P1";
      case 7:
      case 8:
      case 9:
        return "P2";
      case 10:
      case 11:
      case 12:
        return "#,###0.00'x';(#,###0.00'x')";
      default:
        return "P2";
    }
  }

  public pivotTableformatPercentNum(num) {
    switch (num) {
      case 1:
        return "####'%'";
      case 2:
        return "####.0'%'";
      case 3:
        return "####.00'%'";
      default:
        return "####.00'%'";
    }
  }

  public pivotTableformatMultiple(num) {
    switch (num) {
      case 1:
        return "####'x'";
      case 2:
        return "###0.0'x'";
      case 3:
        return "###0.00'x'";
      default:
        return "###0.00'x'";
    }
  }

  public formatNumber(num) {
    switch (num) {
      case 0:
        return "N";
      case 1:
        return "N1";
      case 2:
        return "N2";
      case 3:
        return "N3";
      case 4:
        return "N4";
      case 5:
        return "N5";
      case 6:
        return "N6";
      default:
        return "N2";
    }
  }

  public formatPercent(num) {
    switch (num) {
      case 0:
        return "P";
      case 1:
        return "P1";
      case 2:
        return "P2";
      case 3:
        return "P3";
      case 4:
        return "P4";
      case 5:
        return "P5";
      case 6:
        return "P6";
      default:
        return "P2";
    }
  }

  public formatPercentNum(num) {
    switch (num) {
      case 0:
        return "####'%'";
      case 1:
        return "###0.0'%'";
      case 2:
        return "###0.00'%'";
      default:
        return "###0.00'%'";
    }
  }

  public formatMultiple(num) {
    switch (num) {
      case 0:
        return "####'x'";
      case 1:
        return "###0.0'x'";
      case 2:
        return "###0.00'x'";
      default:
        return "###0.00'x'";
    }
  }

  public GetFigureFormat() {
    // return [
    // 	{ key1: "1,234,567", key2: "(1,234,567)", key3: "-", val: 1 }, //
    // 	{ key1: "1,234,567", key2: "(1,234,567)", key3: "-", val: 2 }, //
    // 	{ key1: "1,234,567.00", key2: "(1,234,567.00)", key3: "-", val: 3 }, //
    // 	{ key1: "1,234,567.00", key2: "(1,234,567.00)", key3: "-", val: 4 }, //
    // 	{ key1: "1", key2: "(1)", key3: "-", val: 5 }, //
    // 	{ key1: "1", key2: "(1)", key3: "-", val: 6 }, //
    // 	{ key1: "1.2", key2: "(1.2)", key3: "0.0", val: 7 }, //
    // 	{ key1: "1.2", key2: "(1.2)", key3: "0.0", val: 8 }, //
    // 	{ key1: "1.23", key2: "(1.23)", key3: "0.00", val: 9 }, //
    // 	{ key1: "1.23", key2: "(1.23)", key3: "0.00", val: 10 }, //
    // ];
    return [
      { key: "1,234,567;(1,234,567);0", val: 1 },
      { key: "1,234,567;(1,234,567);-", val: 2 },
      { key: "1,234,567;(1,234,567);", val: 3 },

      { key: "1,234,567.0;(1,234,567.0);0.0", val: 4 },
      { key: "1,234,567.0;(1,234,567.0);-", val: 5 },
      { key: "1,234,567.0;(1,234,567.0);", val: 6 },

      { key: "1,234,567.00;(1,234,567.00);0.00", val: 7 },
      { key: "1,234,567.00;(1,234,567.00);-", val: 8 },
      { key: "1,234,567.00;(1,234,567.00);", val: 9 },

      { key: "1;(1);0", val: 10 },
      { key: "1;(1);-", val: 11 },
      { key: "1;(1);", val: 12 },

      { key: "1.2;(1.2);0.0", val: 13 },
      { key: "1.2;(1.2);-", val: 14 },
      { key: "1.2;(1.2);", val: 15 },

      { key: "1.23;(1.23);0.00", val: 16 },
      { key: "1.23;(1.23);-", val: 17 },
      { key: "1.23;(1.23);", val: 18 },
    ];
  }

  // public GetFigureFormat2() {
  // 	return [
  // 		// 1234567
  // 		{ key: "1,234,567", val: 11 },
  // 		{ key: "1,234,567.00", val: 12 },
  // 		{ key: "1", val: 13 },
  // 		{ key: "1.2", val: 14 },
  // 		{ key: "1.23", val: 15 },
  // 	];
  // };

  public GetFigureFormat3() {
    // return [
    // 	{ key1: "1,234,567", key2: "(1,234,567)", key3: "-", val: 1 }, //
    // 	{ key1: "1,234,567", key2: "(1,234,567)", key3: "-", val: 2 }, //
    // 	{ key1: "1", key2: "(1)", key3: "-", val: 3 }, //
    // 	{ key1: "1", key2: "(1)", key3: "-", val: 4 }, //
    // 	{ key: "1", val: 5 },
    // ];
    return [
      { key: "1,234,567;(1,234,567);0", val: 1 },
      { key: "1,234,567;(1,234,567);-", val: 2 },
      { key: "1,234,567;(1,234,567);", val: 3 },
      { key: "1;(1);0", val: 4 },
      { key: "1;(1);-", val: 5 },
      { key: "1;(1);", val: 6 },
    ];
  }

  public GetPercentFormats() {
    // return [
    // 	{ key1: "0%", key2: "0%", key3: "-", val: 1 },
    // 	{ key1: "0%", key2: "(0%)", key3: "-", val: 2 },
    // 	{ key1: "0.0%", key2: "0.0%", key3: "-", val: 3 },
    // 	{ key1: "0.0%", key2: "(0.0%)", key3: "-", val: 4 },
    // 	{ key1: "0.00%", key2: "0.00%", key3: "-", val: 5 },
    // 	{ key1: "0.00%", key2: "(0.00%)", key3: "-", val: 6 },
    // ];

    return [
      { key: "1%;(1%);0%", val: 1 },
      { key: "1%;(1%);-", val: 2 },
      { key: "1%;(1%);", val: 3 },

      { key: "1.2%;(1.2%);0.0%", val: 4 },
      { key: "1.2%;(1.2%);-", val: 5 },
      { key: "1.2%;(1.2%);", val: 6 },

      { key: "1.23%;(1.23%);0.00%", val: 7 },
      { key: "1.23%;(1.23%);-", val: 8 },
      { key: "1.23%;(1.23%);", val: 9 },

      { key: "1.23x;(1.23x);0.00x", val: 10 },
      { key: "1.23x;(1.23x);-", val: 11 },
      { key: "1.23x;(1.23x);", val: 12 },
    ];
  }

  public GetMultipleFormats() {
    return [
      { key: "0x", val: 1 },
      { key: "0.0x", val: 2 },
      { key: "0.00x", val: 3 },
    ];
  }

  public getAggregateType(aggregateType) {
    switch (aggregateType) {
      case "CalculateIRR":
        return "CI";
      case "CalculateIRRIRRDate":
        return "CI_IRR";
      case "CalculateIRRBeforeCarried":
        return "CI_BEFORE_CARRY";
      case "CalculateIRRReported":
        return "CI_REPORTED";
      case "CalculateIRRActualAudited":
        return "CI_ACTUAL_AUDITED";
      case "CalculateIRRMTD":
        return "CI_MTD";
      case "CalculateIRRQTD":
        return "CI_QTD";
      case "CalculateIRRYTD":
        return "CI_YTD";
      case "CalculateTWRMTD":
        return "CTWR_MTD";
      case "CalculateTWRQTD":
        return "CTWR_QTD";
      case "CalculateTWRYTD":
        return "CTWR_YTD";
      case "CalculateVARMTD_99":
        return "CVAR_MTD_99";
      case "CalculateVARQTD_99":
        return "CVAR_QTD_99";
      case "CalculateVARYTD_99":
        return "CVAR_YTD_99";
      case "CalculateVARMTD_95":
        return "CVAR_MTD_95";
      case "CalculateVARQTD_95":
        return "CVAR_QTD_95";
      case "CalculateVARYTD_95":
        return "CVAR_YTD_95";
      case "CalculateMultiple":
        return "CM";
      case "CalculatePIC":
        return "CP";
      case "CalculateDPI":
        return "CD";
      case "CalculateTVPI":
        return "CT";
      case "CalculateRVPI":
        return "CR";
      case "CalculateMActualAudited":
        return "CM_ACTUAL_AUDITED";
      case "CalculateMReported":
        return "CM_REPORTED";
    }
  }

  public getCalculateMethod(colName) {
    switch (colName) {
      case "CI":
        return "CalculateIRR";
      case "CI_IRR":
        return "CalculateIRRIRRDate";
      case "CI_BEFORE_CARRY":
        return "CalculateIRRBeforeCarried";
      case "CI_REPORTED":
        return "CalculateIRRReported";
      case "CI_ACTUAL_AUDITED":
        return "CalculateIRRActualAudited";
      case "CI_MTD":
        return "CalculateIRRMTD";
      case "CI_QTD":
        return "CalculateIRRQTD";
      case "CI_YTD":
        return "CalculateIRRYTD";
      case "CTWR_MTD":
        return "CalculateTWRMTD";
      case "CTWR_QTD":
        return "CalculateTWRQTD";
      case "CTWR_YTD":
        return "CalculateTWRYTD";
      case "CVAR_MTD_99":
        return "CalculateVARMTD_99";
      case "CVAR_QTD_99":
        return "CalculateVARQTD_99";
      case "CVAR_YTD_99":
        return "CalculateVARYTD_99";
      case "CVAR_MTD_95":
        return "CalculateVARMTD_95";
      case "CVAR_QTD_95":
        return "CalculateVARQTD_95";
      case "CVAR_YTD_95":
        return "CalculateVARYTD_95";
      case "CM":
        return "CalculateMultiple";
      case "CP":
        return "CalculatePIC";
      case "CD":
        return "CalculateDPI";
      case "CT":
        return "CalculateTVPI";
      case "CR":
        return "CalculateRVPI";
      case "CM_ACTUAL_AUDITED":
        return "CalculateMActualAudited";
      case "CM_REPORTED":
        return "CalculateMReported";
    }
  }

  // 格式化数字
  public number_format(number, decimals, dec_point, thousands_sep, roundtag) {
    /*
     * 参数说明：
     * number：要格式化的数字
     * decimals：保留几位小数
     * dec_point：小数点符号
     * thousands_sep：千分位符号
     * roundtag:舍入参数，默认 "ceil" 向上取,"floor"向下取,"round" 四舍五入
     * */
    number = (number + "").replace(/[^0-9+-Ee.]/g, "");
    roundtag = roundtag || "ceil"; //"ceil","floor","round"
    let n = !isFinite(+number) ? 0 : +number;
    let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    let sep = typeof thousands_sep === "undefined" ? "," : thousands_sep;
    let dec = typeof dec_point === "undefined" ? "." : dec_point;
    // let  s = '';
    let s = (
      prec
        ? this.toFixedFix(n, prec, roundtag)
        : "" + this.pbf.tofixedNum(n, decimals)
    ).split("."); //this.pbf.tofixedNum(Math.abs(value), decimal)
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
      s[0] = s[0].replace(re, "$1" + sep + "$2");
    }

    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  }

  private toFixedFix(n, prec, roundtag) {
    var k = Math.pow(10, prec);
    return (
      "" +
      parseFloat(
        Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2)
      ) /
        k
    );
  }

  public getResultByDataTable(
    portlet,
    isGetTotal = false,
    copyId = false,
    id: string
  ) {
    let result = [];
    let datamartCode = portlet.figureCode;
    let identifier =
      portlet.id === "00000000-0000-0000-0000-000000000000"
        ? portlet.newId
        : portlet.id;
    if (portlet.copyId) {
      identifier = portlet.copyId;
    }
    if (this.portletData_New[id][identifier]) {
      result = isGetTotal
        ? this.portletData_New[id][identifier] &&
          this.portletData_New[id][identifier].total
        : this.portletData_New[id][identifier] &&
          this.portletData_New[id][identifier].data;
    } else {
      result = isGetTotal
        ? this.portletResults_New[id][datamartCode] &&
          this.portletResults_New[id][datamartCode].total
        : this.portletResults_New[id][datamartCode] &&
          this.portletResults_New[id][datamartCode].data;
    }
    return result;
  }

  // SMP2-3708 END

  public getOrderByColumnsNew(datamartCode, dashboard): Promise<any[]> {
    return new Promise((resolve) => {
      if (this.sourcesData[dashboard.id] && dashboard) {
        const outputRes = [];
        if (this.sourcesData[dashboard.id].length) {
          let config = JSON.parse(dashboard.config);
          const dataViews = config.views;
          if (dashboard && dashboard.config) {
            const dataMart = this.sourcesData[dashboard.id].filter(
              (item) => item.entityType === dashboard.entityType
            );
            dataMart.forEach((_data) => {
              _data.views.forEach((view) => {
                if (dataViews.find((item) => item.datamartViewId === view.id)) {
                  view.tables.forEach((table) => {
                    outputRes.push(table);
                  });
                }
              });
            });
          }
        }
        resolve(outputRes);
      } else {
        // 处理 this.sourcesData 没有值
        let data = {
          accountId: this.userInfo.accountId,
          language: this.lang,
          dashboardVersion: 2,
        };
        this.http.post(this.api.urlList.GetSources, data, (res) => {
          const outputRes = [];
          if (res && res.length) {
            this.sourcesData[dashboard.id] = res;
            let config = JSON.parse(dashboard.config);
            const dataViews = config.views;
            if (dashboard && dashboard.config) {
              const dataMart = res.filter(
                (item) => item.entityType === dashboard.entityType
              );
              dataMart.forEach((_data) => {
                _data.views.forEach((view) => {
                  if (
                    dataViews.find((item) => item.datamartViewId === view.id)
                  ) {
                    view.tables.forEach((table) => {
                      outputRes.push(table);
                    });
                  }
                });
              });
            }
          }
          resolve(outputRes);
        });
      }
    });
  }

  public async decompressArrayBuffer(input: ArrayBuffer): Promise<Uint8Array> {
    //create the stream
    const ds = new (window as any).DecompressionStream("deflate-raw");
    //create the writer
    const writer = ds.writable.getWriter();
    //write the buffer to the writer thus decompressing it
    writer.write(input);
    writer.close();
    //create the output
    const output: Uint8Array[] = [];
    //create the reader
    const reader = ds.readable.getReader();
    let totalSize = 0;
    //go through each chunk and add it to the output
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      output.push(value);
      totalSize += value.byteLength;
    }
    const concatenated = new Uint8Array(totalSize);
    let offset = 0;
    //finally build the compressed array and return it
    for (const array of output) {
      concatenated.set(array, offset);
      offset += array.byteLength;
    }
    return concatenated;
  }

  private getAllFields(item, dashboard): Promise<any[]> {
    const lang = this.pbf.getLanguageParams();
    return new Promise((resolve, reject) => {
      const dataMartCode = item.figureCode;
      const dataObj = {
        language: lang,
        dataMartCode,
      };
      this.setSchemaParams(dataObj, dataMartCode, dashboard);
      this.http.post(this.api.urlList.GetSchema, dataObj, (res) => {
        resolve(res);
      });
    });
  }

  public setSchemaParams(dataObj, figureCode, dashboard) {
    if (this.checkIsQ2Q(dashboard.dataMartTables)) {
      dataObj["fromDate"] = dashboard.fromDate;
      dataObj["asOfDate"] = dashboard.asOfDate;
    } else if (figureCode.indexOf("FinancialFigure") !== -1) {
      dataObj["entityType"] = dashboard.entityList.map(
        (item) => item.linkedType
      );
      dataObj["fromDate"] = dashboard.fromDate || "";
      dataObj["asOfDate"] = dashboard.asOfDate;
    }
    if (
      dashboard &&
      (figureCode === "FundOperations" ||
        figureCode === "FundOperationTableSequoia" ||
        figureCode.indexOf("FinancialFigure") !== -1)
    ) {
      dataObj["entityIds"] = dashboard.entityList.map(
        (item) => item.linkedGuid
      );
    }
  }

  // 判断是否可选开始日期
  public checkHasFromDate(dataMart) {
    const has = dataMart.find(
      (item) =>
        !item.isHide && item.datamartCode === "FundOperationTableSequoia"
    );
    return !!has;
  }

  // 判断Q2Q，控制顶部日期选择类型
  public checkIsQ2Q(dataMart) {
    return false;
    const Q2QPatchList = [
      "SeeThroughHisPosition",
      "SeeThroughHisPositionByInvestor",
    ];
    const has = dataMart.find((it) => {
      return !it.isHide && Q2QPatchList.includes(it.datamartCode);
    });
    return !!has;
  }

  /**
   * 使用自定义保存的列数据，覆盖通用列配置数据
   * @param allFields 自定义数据
   * @param fields 通用列配置数据
   * @returns
   */
  public setConfigFields(allFields, fields) {
    allFields.forEach((_field) => {
      fields.forEach((field) => {
        if (_field.colName === field.colName) {
          _field.isHidden = field.isHidden;
          _field.visible = field.visible;
          _field.format = field.format;
          _field.formula = field.formula;
          if (field.showGrandTotals !== undefined) {
            _field.showGrandTotals = field.showGrandTotals;
          }
          if (field.showSubTotals !== undefined) {
            _field.showSubTotals = field.showSubTotals;
          }
        }
      });
    });
    fields.forEach((field) => {
      if (field.isCalculatedField) {
        allFields.push(field);
      }
    });
    const fieldsName = [];
    const outputFields = [];
    allFields.forEach((field) => {
      // q2q当中langCode很多相同，去重要多判断一下addtionName
      // if (!fieldsName.includes(field.langCode) || !!field.addtionName) {
      if (
        !fieldsName.includes(field.langCode) &&
        !fieldsName.includes(field.langValue)
      ) {
        const value = field.langCode || field.langValue;
        fieldsName.push(value);
        outputFields.push(field);
      }
    });
    return outputFields.sort((a, b) => (a.seq >= b.seq ? 1 : -1));
  }

  public async getDataByPortletsNew(
    portlets,
    callback,
    pageSetting?,
    isRefresh = false,
    dashboard?: any,
    roGet = false
  ) {
    let length = 0;
    if (portlets && portlets.length) {
      for (let portlet of portlets) {
        let id =
          portlet.id === "00000000-0000-0000-0000-000000000000"
            ? portlet.newId
            : portlet.id;
        const allFields = await this.getAllFields(portlet, dashboard);
        let params = this.getParamsByPortlet(
          portlet,
          pageSetting,
          allFields,
          dashboard
        );
        let initFieldsArr;
        let curFieldsArr;
        if (!params.isTable && !roGet) {
          // 赋值portletFields_Temp
          initFieldsArr = this.portletFields_Temp[id];
          curFieldsArr = params.displayColumnFilter.split(",");
          if (
            !initFieldsArr ||
            this.needGetPortletData(initFieldsArr, curFieldsArr)
          ) {
            this.portletFields_Temp[id] = curFieldsArr;
          } else {
            length++;
            if (portlets.length === length) {
              callback();
            }
            continue;
          }
        }
        const config = portlet.config && JSON.parse(portlet.config);
        if (config.filterSettings && config.filterSettings.length) {
          if (!params.columnFilter) {
            params.columnFilter = [];
          }
          config.filterSettings.forEach((setting) => {
            if (config.portletType === "pivot") {
              return;
            }
            const _field = config.fields.find(
              (item) => item.colName === setting.name
            );
            const Type = _field && _field.dataType;
            if (setting.items) {
              setting.items.forEach((item) => {
                params.columnFilter.push({
                  Field: setting.name,
                  Operator: "equal",
                  Type,
                  Value:
                    Type === "date"
                      ? moment(item).format("yyyy-MM-DD")
                      : Type === "datetime"
                      ? moment(item).format("yyyy-MM-DD hh:mm:ss")
                      : item,
                });
              });
            } else if (setting.operator) {
              params.columnFilter.push({
                Field: setting.field,
                Operator: "equal",
                Type: setting.type,
                Value:
                  setting.type === "date"
                    ? moment(setting.value).format("yyyy-MM-DD")
                    : setting.type === "datetime"
                    ? moment(setting.value).format("yyyy-MM-DD hh:mm:ss")
                    : setting.value,
              });
            }
          });
        }
        if (params.columnFilter instanceof Array) {
          params.columnFilter = params.columnFilter.filter(
            (item) => item.Field
          );
        }

        // json buffer
        params["dashboardVersion"] = 2;
        this.httpClient
          .post(
            this.api.baseurl + this.api.urlList.GetPortletDataOrCreate,
            params,
            {
              headers: new HttpHeaders({
                Authorization: `Bearer`,
              }),
            }
          )
          .subscribe(
            (result) => {
              if (!result) {
                this.portletData_New[dashboard.id][id] = {
                  total: 0,
                  data: [],
                };
                if (isRefresh) {
                  this.DashboardService.refreshGadget.next({
                    newId: id,
                  });
                }
                length++;
                if (isRefresh) {
                  this.DashboardService.refreshGadget.next({
                    newId: id,
                  });
                }
                if (portlets.length === length) {
                  if (isRefresh) {
                    this.DashboardService.startRefresh.next(false);
                  }
                  callback();
                }
              } else {
                result["data"].forEach((item) => {
                  item.Sector = this.translation[item.Sector] || item.Sector;
                });
                this.portletData_New[dashboard.id][id] = result;
                if (isRefresh) {
                  this.DashboardService.refreshGadget.next({
                    newId: id,
                  });
                }
                length++;
                if (portlets.length === length) {
                  if (isRefresh) {
                    this.DashboardService.startRefresh.next(false);
                  }
                  callback();
                }
              }
            },
            (response) => {
              this.portletFields_Temp[id] = initFieldsArr;
              length++;
              if (portlets.length === length) {
                callback();
              }
            },
            () => {}
          );
      }
    } else {
      callback();
    }
  }

  public clearFieldsObj(portlet) {
    Reflect.deleteProperty(this.allFieldsObj, portlet.id);
  }

  // 根据portlet 解析params
  public getParamsByPortlet(
    portlet,
    pageSetting?,
    allFields?: any[],
    dashboard?: any
  ) {
    let dashboardDataTableId = portlet.dashboardDataTableId;
    //SMP2-7731 get the dashboardDataTableid from dataMartTables arrary
    let curDataMart = this.dataMartTables[dashboard.id].find(
      (d) => d.datamartCode === portlet.figureCode
    );
    if (curDataMart) {
      dashboardDataTableId = curDataMart.id;
    }

    let config = portlet.config && JSON.parse(portlet.config);
    if (portlet.id !== "00000000-0000-0000-0000-000000000000") {
      this.allFieldsObj[portlet.id] = allFields;
    }
    let fields = allFields
      ? this.setConfigFields(allFields, config.fields)
      : config.fields;
    if (allFields) {
      config.fields = fields;
      portlet.config = JSON.stringify(config);
    }
    let calculatedFields = config.calculatedFieldSettings;
    let needFields = [];
    let params: any = {};
    const portletType =
      config.portletType === "historicalIRR"
        ? config.selectedVisualType
        : config.portletType;
    if (portletType === "table") {
      fields &&
        fields.forEach((x) => {
          needFields.push(x.colName);
        });

      params.startIndex = 0;
      params.pageSize = 10;
      if (pageSetting && pageSetting.currentPage) {
        params.startIndex =
          (pageSetting.currentPage - 1) * pageSetting.pageSize;
        params.pageSize = pageSetting.pageSize;
      }
      // 处理 sort
      if (pageSetting && pageSetting.sortedColumn) {
        params.sortedColumn = pageSetting.sortedColumn;
        params.sort = pageSetting.sort;
      }
      // 处理 filter
      if (config.filterSettings.length) {
        let filterSettings = JSON.parse(JSON.stringify(config.filterSettings));
        params.columnFilter = filterSettings.map((x) => {
          if (x.type === "date") {
            const date = new Date(x.value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const formattedDate = `${year}-${month}-${day}`;
            x.value = formattedDate;
          }
          return x;
        });
      }
      params.isTable = true;
    } else if (portletType === "transpose") {
      fields &&
        fields.forEach((x) => {
          if (!x.isHidden) {
            needFields.push(x.colName);
          }
        });
    } else if (
      ["newcolumn", "newline", "newcolumnline"].includes(portletType)
    ) {
      if (config.selectedY && config.selectedY.length > 0) {
        config.selectedY.forEach((e) => {
          needFields.push(e);
        });
      }
      if (config.selectedSecondY && config.selectedSecondY.length > 0) {
        config.selectedSecondY.forEach((e) => {
          needFields.push(e);
        });
      }
    } else {
      // 处理 filters
      let filters = config.filters;
      if (filters && filters.length) {
        for (let item of filters) {
          needFields.push(item.name);
        }
      }

      // 处理 values
      let series = config.yaxis.series;
      if (series && series.length) {
        for (let item of series) {
          if (
            [
              "CalculateIRR",
              "CalculateIRRMTD",
              "CalculateIRRQTD",
              "CalculateIRRYTD",
              "CalculateTWRMTD",
              "CalculateTWRQTD",
              "CalculateTWRYTD",
              "CalculateVARMTD_99",
              "CalculateVARQTD_99",
              "CalculateVARYTD_99",
              "CalculateVARMTD_95",
              "CalculateVARQTD_95",
              "CalculateVARYTD_95",
            ].includes(item.calMethod)
          ) {
            needFields.push("IRRAmount", "IRRDate", "IRRAdjValue");
          } else if (item.calMethod === "CalculateIRRBeforeCarried") {
            needFields.push("IRRAmount", "IRRDate", "IRRAdjValueBeforeCarry");
          } else if (item.calMethod === "CalculateIRRIRRDate") {
            needFields.push("IRRAmount", "CalculateIRRDate", "IRRAdjValue");
          } else if (item.calMethod === "CalculateIRRActualAudited") {
            portlet.figureCode === "GrossNet" ||
            portlet.figureCode === "CombinedInvestmentFundNCompanyCashflow"
              ? needFields.push("IRRAmount", "IRRDate", "ActualAuditedNAV")
              : needFields.push("IRRAmount", "IRRDate", "IRRAdjValue");
          } else if (item.calMethod === "CalculateIRRReported") {
            portlet.figureCode === "GrossNet" ||
            portlet.figureCode === "CombinedInvestmentFundNCompanyCashflow"
              ? needFields.push("IRRAmount", "IRRDate", "ReportedNAV")
              : needFields.push("IRRAmount", "IRRDate", "IRRAdjValue");
          } else if (item.calMethod === "CalculatedField") {
          } else {
            let colName = this.getAggregateType(item.calMethod);
            if (colName) {
              let curField = fields.find((f) => f.colName === colName);
              if (curField && curField.formula) {
                let fs = curField.formula.split("/");
                fs && fs.map((f) => needFields.push(f));
              }
            } else {
              needFields.push(item.colName);
            }
          }
        }
      }
      // 处理 rows
      let groups = config.xaxis.groups;
      if (groups && groups.length) {
        for (let gitem of groups) {
          needFields.push(gitem.name);
        }
      }
      // 处理 colunms
      let columnGroup = config.columnGroup;
      if (columnGroup && columnGroup.length) {
        for (let item of columnGroup) {
          needFields.push(item.name);
        }
      }
      // 处理 calculatedField
      if (calculatedFields && calculatedFields.length) {
        calculatedFields.map((f) => {
          let string = f.formula;
          const regex = /\((.*?)\)/g;
          const matches = string
            .match(regex)
            .map((match) => match.slice(1, -1));
          needFields.push(...matches);
        });
      }
      // 处理 orderByColumns
      if (this.dashboardConfig && this.dashboardConfig[dashboard.id]) {
        params.datamartViewId =
          this.dashboardConfig[dashboard.id].datamartViewId;
        params.datamartId = this.dashboardConfig[dashboard.id].datamartId;
        params.datamartCode = portlet.figureCode;
      }
      // 处理config.fields里的sortColumn
      let fieldSortColumns = [];
      fields.map((x) => {
        if (x.sortColumn && !fieldSortColumns.includes(x.sortColumn)) {
          fieldSortColumns.push(x.sortColumn);
        }
      });
      if (fieldSortColumns.length) {
        needFields.push(...fieldSortColumns);
      }
    }

    needFields = Array.from(new Set(needFields));
    // 去除非法字段
    let legalFields = fields.map((x) => x.colName);
    needFields.map((x, i) => {
      if (!legalFields.includes(x)) {
        needFields.splice(i, 1);
      }
    });
    if (needFields.length === 0) {
      if (legalFields[0]) {
        needFields.push(legalFields[0]);
      }
    }
    // 默认获取Seq字段 SMP2-4582 AGIC - Dashboard item sequence
    needFields.push("Seq");

    // "newcolumn", "newline", "newcolumnline" 如果是这三种类型默认加 OperationDate 字段
    if (["newcolumn", "newline", "newcolumnline"].includes(portletType)) {
      needFields.push(config.selectedX);
      params["IsOnlyShowDisplayColum"] = true;
    }
    if (config.portletType === "historicalIRR") {
      if (!params.columnFilter) {
        params.columnFilter = [];
      }
      params.columnFilter.push(
        {
          Field: "Frequencys",
          Operator: "equal",
          Type: "string",
          Value: config.selectedMultiples,
        },
        {
          Field: "InvestorType",
          Operator: "equal",
          Type: "string",
          Value: config.selectedInvestor,
        }
      );
    }
    params.dashboardDataTableId = dashboardDataTableId;
    params.displayColumnFilter = needFields.join(",");
    params.responseType = "json";
    return params;
  }

  // 是否需要重新发起请求
  public needGetPortletData(origin = [], compare = []) {
    return compare.some((c) => !origin.includes(c));
  }

  public setDataManager(
    figureCodes,
    callback,
    portletTypes = [],
    dashboardId,
    portlet?: any
  ) {
    let length = 0;
    if (!this.fieldsArr[dashboardId]) {
      this.fieldsArr[dashboardId] = {};
    }
    if (
      this.dataMartTables[dashboardId] &&
      this.dataMartTables[dashboardId].length
    ) {
      this.pbf.pageLoading = true;
      this.pbf.pageLoading_.next(true);
      let dataMartTables = this.dataMartTables[dashboardId].filter((el) =>
        figureCodes.includes(el.datamartCode)
      );
      if (dataMartTables.length) {
        forEach(dataMartTables, (item, index) => {
          let allFields;
          let config;
          if (portlet) {
            config = JSON.parse(portlet.config);
          }
          if (
            ["newcolumn", "newline", "newcolumnline"].includes(portletTypes[0])
          ) {
            allFields = config.selectedY
              .concat(config.selectedSecondY)
              .concat([config.selectedX])
              .map((e) => {
                return {
                  colName: e,
                };
              });
          } else {
            allFields =
              this.fieldsArr[dashboardId] &&
              this.fieldsArr[dashboardId][item.datamartCode]
                ? this.fieldsArr[dashboardId][item.datamartCode]
                : [];
          }
          let displayColumnFilter =
            allFields && allFields.map((x) => x.colName).join(",");
          let params: any = {
            dashboardDataTableId: item.id,
            displayColumnFilter: displayColumnFilter,
            responseType: "json",
            dashboardVersion: 2,
          };
          params.startIndex = 0;
          params.pageSize = 10;

          if (
            portletTypes &&
            portletTypes.length > 0 &&
            (portletTypes.includes("newcolumn") ||
              portletTypes.includes("newline") ||
              portletTypes.includes("newcolumnline"))
          ) {
            params.pageSize = 1000000;
            params["IsOnlyShowDisplayColum"] = true;
          }

          if (config) {
            const filterSettings = config.filterSettings;

            if (filterSettings && filterSettings.length) {
              if (!params.columnFilter) {
                params.columnFilter = [];
              }
              filterSettings.forEach((setting) => {
                if (config.portletType === "pivot") {
                  return;
                }
                const _field = config.fields.find(
                  (item) => item.colName === setting.name
                );
                const Type = _field && _field.dataType;
                if (setting.items) {
                  setting.items.forEach((item) => {
                    params.columnFilter.push({
                      Field: setting.name,
                      Operator: "equal",
                      Type,
                      Value:
                        Type === "date"
                          ? moment(item).format("yyyy-MM-DD")
                          : Type === "datetime"
                          ? moment(item).format("yyyy-MM-DD hh:mm:ss")
                          : item,
                    });
                  });
                } else if (setting.operator) {
                  params.columnFilter.push({
                    Field: setting.field,
                    Operator: "equal",
                    Type: setting.type,
                    Value:
                      setting.type === "date"
                        ? moment(setting.value).format("yyyy-MM-DD")
                        : setting.type === "datetime"
                        ? moment(setting.value).format("yyyy-MM-DD hh:mm:ss")
                        : setting.value,
                  });
                }
              });
            }
            if (config.portletType === "historicalIRR") {
              if (!params.columnFilter) {
                params.columnFilter = [];
              }
              params.columnFilter.push(
                {
                  Field: "Frequencys",
                  Operator: "equal",
                  Type: "string",
                  Value: config.selectedMultiples,
                },
                {
                  Field: "InvestorType",
                  Operator: "equal",
                  Type: "string",
                  Value: config.selectedInvestor,
                }
              );
            }
          }
          if (params.columnFilter instanceof Array) {
            params.columnFilter = params.columnFilter.filter(
              (item) => item.Field
            );
          }

          // json buffer
          this.httpClient
            .post(
              this.api.baseurl + this.api.urlList.GetPortletDataOrCreate,
              params,
              {
                headers: new HttpHeaders({
                  Authorization: `Bearer`,
                }),
              }
            )
            .subscribe(
              (result) => {
                let identifier =
                  portlet.id === "00000000-0000-0000-0000-000000000000"
                    ? portlet.newId
                    : portlet.id;
                if (!result) {
                  this.portletResults_New[dashboardId][item.datamartCode] = [];
                  if (portlet) {
                    this.portletData_New[dashboardId][identifier] = {
                      total: 0,
                      data: [],
                    };
                  }
                  let message = this.translation.NO_DATA
                    ? this.translation.NO_DATA
                    : ".No data, please choose another data type";
                  this.dialogService.showNotification(message, {
                    status: "Error",
                  });
                  length++;
                  if (dataMartTables.length === length) {
                    callback();
                  }
                } else {
                  result["data"].forEach((item) => {
                    item.Sector = this.translation[item.Sector] || item.Sector;
                  });
                  if (
                    this.fieldsArr[dashboardId] &&
                    Object.keys(this.fieldsArr[dashboardId]).length
                  ) {
                    this.portletResults_New[dashboardId][item.datamartCode] =
                      result;
                  }
                  if (portlet) {
                    this.portletData_New[dashboardId][identifier] = result;
                  }
                  length++;
                  if (dataMartTables.length === length) {
                    callback();
                  }
                }
              },
              (response) => {
                length++;
                if (dataMartTables.length === length) {
                  callback();
                }
              },
              () => {}
            );
        });
      } else {
        callback();
      }
    }
  }

  public ExcelFormulas = {
    DaysBetween: function (date1, date2) {
      var oneDay = 24 * 60 * 60 * 1000;
      return Math.round(Math.abs((date1.getTime() - date2.getTime()) / oneDay));
    },
    XNPV: function (rate, values) {
      var xnpv = 0.0;
      var firstDate = new Date(values[0].date);
      for (var key in values) {
        var tmp = values[key];
        var value = tmp.amount;
        var date = new Date(tmp.date);
        xnpv +=
          value / Math.pow(1 + rate, this.DaysBetween(firstDate, date) / 365);
      }
      return xnpv;
    },
    XIRR: function (values, guess) {
      var x1 = 0.0;
      var x2: number = guess;
      var f1 = this.XNPV(x1, values);
      var f2 = this.XNPV(x2, values);
      for (var i = 0; i < 100; i++) {
        if (f1 * f2 < 0.0) break;
        if (Math.abs(f1) < Math.abs(f2)) {
          f1 = this.XNPV((x1 += 1.6 * (x1 - x2)), values);
        } else {
          f2 = this.XNPV((x2 += 1.6 * (x2 - x1)), values);
        }
      }
      if (f1 * f2 > 0.0) return null;
      var f = this.XNPV(x1, values);
      if (f < 0.0) {
        var rtb = x1;
        var dx = x2 - x1;
      } else {
        var rtb = x2;
        var dx = x1 - x2;
      }
      for (var i = 0; i < 100; i++) {
        dx *= 0.5;
        var x_mid = rtb + dx;
        var f_mid = this.XNPV(x_mid, values);
        if (f_mid <= 0.0) rtb = x_mid;
        if (Math.abs(f_mid) < 1.0e-6 || Math.abs(dx) < 1.0e-6) return x_mid;
      }
      return null;
    },
    _DaysBetween: function (date1, date2) {
      //const time1 =new Date(Date.UTC(date1.getUTCFullYear(), date1.getUTCMonth(), date1.getUTCDate(), date1.getUTCHours(), date1.getUTCMinutes(), date1.getUTCSeconds())).getTime();
      //const time2 =new Date(Date.UTC(date2.getUTCFullYear(), date2.getUTCMonth(), date2.getUTCDate(), date2.getUTCHours(), date2.getUTCMinutes(), date2.getUTCSeconds())).getTime();
      const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
      //const time1 = date1.getTime(); // date1的毫秒表示
      //const time2 = date2.getTime(); // date2的毫秒表示
      const firstDate = new Date(date1);
      const secondDate = new Date(date2);
      const diffDays = Math.round(
        // @ts-ignore
        Math.abs((firstDate - secondDate) / oneDay)
      ); // 计算天数差并取整
      return diffDays;
    },

    _lcl_sca_XirrResult: function (values, dates, fRate) {
      var D_0 = dates[0];
      let r = fRate + 1.0;
      var fResult = values[0];
      for (var i = 1, nCount = values.length; i < nCount; ++i) {
        var temp = Math.pow(r, this._DaysBetween(dates[i], D_0) / 365.0);
        fResult += values[i] / temp;
      }
      return fResult;
    },

    _lcl_sca_XirrResult_Deriv1: function (values, dates, fRate) {
      var D_0 = dates[0];
      var r = fRate + 1.0;
      var fResult = 0.0;
      for (var i = 1, nCount = values.length; i < nCount; ++i) {
        var E_i = this._DaysBetween(dates[i], D_0) / 365.0;
        fResult -= (E_i * values[i]) / Math.pow(r, E_i + 1.0);
      }
      return fResult;
    },

    _CalculateXirrOpenOffice: function (values, dates, guess) {
      if (values.length < 2 || values.length != dates.length) {
        return null;
      }

      var fResultRate = guess;
      if (fResultRate <= -1) {
        return null;
      }

      var fMaxEps = 0.00000001;
      var nMaxIter = 50;

      var fNewRate, fRateEps, fResultValue;
      var nIter = 0;
      var nIterScan = 0;
      var bContLoop = false;
      var bResultRateScanEnd = false;

      do {
        if (nIterScan >= 1) {
          fResultRate = -0.99 + (nIterScan - 1) * 0.01;
        }
        do {
          fResultValue = this._lcl_sca_XirrResult(values, dates, fResultRate);
          fNewRate =
            fResultRate -
            fResultValue /
              this._lcl_sca_XirrResult_Deriv1(values, dates, fResultRate);
          fRateEps = Math.abs(fNewRate - fResultRate);
          fResultRate = fNewRate;
          bContLoop = fRateEps > fMaxEps && Math.abs(fResultValue) > fMaxEps;
        } while (bContLoop && ++nIter < nMaxIter);
        nIter = 0;
        if (
          isNaN(fResultRate) ||
          !isFinite(fResultRate) ||
          isNaN(fResultValue) ||
          !isFinite(fResultValue)
        ) {
          bContLoop = true;
        }

        ++nIterScan;
        bResultRateScanEnd = nIterScan >= 100;
      } while (bContLoop && !bResultRateScanEnd);

      if (bContLoop) {
        return null;
      }
      return fResultRate;
    },

    _CalculateXirr: function (valueList, dateList, navAdjust, latestDate) {
      var positiveCashflow = valueList.some(function (v) {
        return v > 0;
      })
        ? true
        : navAdjust > 0
        ? true
        : false;
      var negativeCashflow = valueList.some(function (v) {
        return v < 0;
      })
        ? true
        : navAdjust < 0
        ? true
        : false;

      if (positiveCashflow == false || negativeCashflow == false) {
        return null;
      }

      if (navAdjust != null) {
        valueList.push(navAdjust);
        dateList.push(latestDate);
      }

      var xirrResult = null;
      try {
        var excelGuess =
          valueList.reduce(function (sum, value) {
            return sum + value;
          }, 0) < 0
            ? -0.1
            : 0.1;
        xirrResult = this._CalculateXirrOpenOffice(
          valueList,
          dateList,
          excelGuess
        );
      } catch (error) {
        return null;
      }

      return xirrResult;
    },
  };

  // 拿到数据后，先遍历config.filterSettings,如果在数据中不存在，就删除这一项
  checkFilterSettings(config, fields, data) {
    let filterSettings = config.filterSettings;
    if (filterSettings && filterSettings.length) {
      for (let i = 0; i < filterSettings.length; i++) {
        const element = filterSettings[i];
        let __field = fields.filter(
          (field) => field.colName == element.name
        )[0];
        if (!__field) {
          // 处理自定义 Group的Filter
          continue;
        }
        const dataType = __field.dataType;
        if (element.items && element.items.length) {
          for (let r = 0; r < element.items.length; r++) {
            const item = element.items[r];
            let res = [];
            if (
              dataType !== "date" &&
              dataType !== "datetime" &&
              data &&
              data.length
            ) {
              if (dataType == "string") {
                res = data.filter((obj) => obj[element.name] === item);
              } else {
                res = data.filter(
                  (obj) => Number(obj[element.name]) === Number(item)
                );
              }
            }
            if (dataType == "date" || dataType == "datetime") {
              res = data.filter(
                (obj) =>
                  moment(obj[element.name]).format("YYYY-MM-DD") ==
                  moment(item).format("YYYY-MM-DD")
              );
            }
            if (!res.length) {
              element.items.splice(r, 1);
              r--;
            }
          }
          if (!element.items.length) {
            filterSettings.splice(i, 1);
            i--;
          }
        }
      }
      return filterSettings;
    } else {
      return [];
    }
    // callback(filterSettings);
  }

  sortDataMartTables(data) {
    data.sort((a, b) => {
      const langValueA = a.langValue.toLowerCase();
      const langValueB = b.langValue.toLowerCase();

      if (langValueA < langValueB) {
        return -1;
      }
      if (langValueA > langValueB) {
        return 1;
      }
      return 0;
    });
  }

  renameDataMartTables(data, id, entityType) {
    if (this.sourcesData[id]) {
      this.sourcesData[id].forEach((sources) => {
        if (sources.entityType === entityType) {
          data.forEach((_data) => {
            sources.views.forEach((view) => {
              view.tables.forEach((table) => {
                if (table.datamartCode === _data.datamartCode) {
                  _data.langValue = table.langValue;
                  _data.langCode = table.langCode;
                }
              });
            });
          });
        }
      });
    } else {
      return data;
    }
  }
}
export const ALL_AGGREGATE_TYPES = [
  "Sum",
  "First",
  "Last",
  "CalculateIRR",
  "CalculateIRRIRRDate",
  "CalculateIRRBeforeCarried",
  "CalculateIRRActualAudited",
  "CalculateIRRReported",
  "CalculateIRRMTD",
  "CalculateIRRQTD",
  "CalculateIRRYTD",
  "CalculateTWRMTD",
  "CalculateTWRQTD",
  "CalculateTWRYTD",
  "CalculateVARMTD_99",
  "CalculateVARQTD_99",
  "CalculateVARYTD_99",
  "CalculateVARMTD_95",
  "CalculateVARQTD_95",
  "CalculateVARYTD_95",
  "CalculateMultiple",
  "CalculatePIC",
  "CalculateDPI",
  "CalculateTVPI",
  "CalculateRVPI",
  "CalculateMActualAudited",
  "CalculateMReported",
  "Count",
  "DistinctCount",
  "Product",
  "Min",
  "Max",
  "Avg",
  "Median",
  "Index",
  "PopulationVar",
  "SampleVar",
  "PopulationStDev",
  "SampleStDev",
  "RunningTotals",
  "PercentageOfGrandTotal",
  "PercentageOfColumnTotal",
  "PercentageOfRowTotal",
  "PercentageOfParentColumnTotal",
  "PercentageOfParentRowTotal",
  "DifferenceFrom",
  "PercentageOfDifferenceFrom",
  "PercentageOfParentTotal",
];

let translation = getTranslation()
export const AGGREGATE_TYPES_TEXT = {
  CalculateIRR: translation.CALCULATE_IRR || "Calculate IRR",
  CalculateIRRIRRDate:
    translation.CALCULATE_IRR_IRR_DATE || "Calculate IRR (IRR Date)",
  CalculateIRRBeforeCarried:
    translation.CALCULATE_IRR_BEFORE_CARRY || "Calculate IRR Before Carried",
  CalculateIRRActualAudited:
    translation.CALCULATE_IRR_ACTUAL_AUDITED || "Calculate IRR Actual/Audited",
  CalculateIRRReported: translation.CI_REPORTED || "Calculate IRR Reported",
  CalculateIRRMTD: translation.CALCULATE_IRR_MTD || "Calculate IRR (MTD)",
  CalculateIRRQTD: translation.CALCULATE_IRR_QTD || "Calculate IRR (QTD)",
  CalculateIRRYTD: translation.CALCULATE_IRR_YTD || "Calculate IRR (YTD)",
  CalculateTWRMTD: translation.CALCULATE_TWR_MTD || "Calculate TWR (M)",
  CalculateTWRQTD: translation.CALCULATE_TWR_QTD || "Calculate TWR (Q)",
  CalculateTWRYTD: translation.CALCULATE_TWR_YTD || "Calculate TWR (Y)",
  CalculateVARMTD_99:
    translation.CALCULATE_VAR_MTD_99 || "Calculate VAR (M 99%)",
  CalculateVARQTD_99:
    translation.CALCULATE_VAR_QTD_99 || "Calculate VAR (Q 99%)",
  CalculateVARYTD_99:
    translation.CALCULATE_VAR_YTD_99 || "Calculate VAR (Y 99%)",
  CalculateVARMTD_95:
    translation.CALCULATE_VAR_MTD_95 || "Calculate VAR (M 95%)",
  CalculateVARQTD_95:
    translation.CALCULATE_VAR_QTD_95 || "Calculate VAR (Q 95%)",
  CalculateVARYTD_95:
    translation.CALCULATE_VAR_YTD_95 || "Calculate VAR (Y 95%)",
  CalculateMultiple: translation.CALCULATE_MULTIPLE || "Calculate Multiple",
  CalculatePIC: translation.CALCULATE_PIC || "Calculate PIC",
  CalculateDPI: translation.CALCULATE_DPI || "Calculate DPI",
  CalculateTVPI: translation.CALCULATE_TVPI || "Calculate TVPI",
  CalculateRVPI: translation.CALCULATE_RVPI || "Calculate RVPI",
  CalculateMActualAudited:
    translation.CALCULATE_MULTIPLE_ACTUAL_AUDITED ||
    "Calculate Multiple Actual/Audited",
  CalculateMReported:
    translation.CALCULATE_MULTIPLE_REPORTED || "Calculate Multiple Reported",
  First: translation.FIRST || "First",
  Last: translation.LAST || "Last",
  Median: translation.MEDIAN || "Median",
};
